export default "__VITE_ASSET__KyV0pSf8__"